<template>
    <div class="login-main-container">
        <div class="login-center-container pt-15 pb-8">
            <!--<div class="text-center mt-15">
                <img src="../assets/images/balady.png" alt="" class="mb-0">
            </div>-->
            <v-card :loading="loading" elevation="3" class="mt-15 pb-7 ps-6 pe-6">
                <v-container>
                    <div class="text-center pt-4 pb-4">
                        <h3 class="tile">{{ $t("ApplicationName") }}</h3>
                        <div class="grey--text mb-2">{{ $t("LoginToAccount") }}</div>
                    </div>
                    <v-layout column>
                        <v-text-field v-model="username" :label="$t('Username')" outlined color="primary" autocomplete="false"
                                      prepend-inner-icon="mdi-account" @keydown.enter.prevent="login()" />
                        <v-text-field v-model="password" color="primary" type="password" :label="$t('Password')" outlined
                                      autocomplete="false" prepend-inner-icon="mdi-lock" @keydown.enter.prevent="login()" />

                        <div class="captcha-container">                                 
                            <img :src="captchaImage" />
                            <v-text-field dense outlined v-model="userInput" class="captcha-input" @keydown.enter="login" :placeholder="$t('Captcha')" append-outer-icon="mdi-reload" @click:append-outer="generateCaptcha" />
                        </div>

                        <v-btn class="white--text" color="primary" block :disabled="disableLogin" @click="login">
                            {{ $t("Login") }}
                        </v-btn>
                        <div v-if="errorLogin" class="mt-2 ms-2 me-2 error--text">{{ $t("InvalidLogin") }}</div>
                        <div v-if="errorLocked" class="mt-2 ms-2 me-2 error--text">{{ $t("UserLocked") }}</div>
                        <div v-if="errorCaptcha" class="mt-2 ms-2 me-2 error--text">{{ $t('CaptchaVerificationFailed') }}</div>
                    </v-layout>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AuthService from '@/services/AuthService'
    export default {
        data() {
            return {
                username: '',
                password: '',
                loading: false,
                errorLogin: false,
                errorLocked: false,
                errorCaptcha: false,
                captchaLength: 6,
                captchaText: '',
                captchaTextArray: [],
                userInput: '',
                guidId: '',
                verificationResult: null,
                rotation: '',
                captchaImage:''
            }
        },
        filters: {
            reverse: function (array) {
                return array.slice().reverse()
            }
        },
        computed: {
            ...mapGetters('user', ['language']),

            disableLogin() {
                return this.loading || !this.username || !this.password
            },
            getLanguage() {
                return this.language == null ? 'ar' : this.language

            }
        },
        mounted() {
            this.generateCaptcha()
        },
        methods: {
            generateCaptcha() {
                AuthService.captcha()
                    .then(result => {                        
                        this.guidId = result.guidId
                        this.captchaImage = 'data:image/png;base64,' + result.captchaImage
                    })
                    .catch(error => {
                        console.error('Error loading CAPTCHA image:', error)
                    })

            },
            async verifyCaptcha() {
                if (!this.userInput || !this.guidId) {
                    this.errorCaptcha = true
                    return false
                }

                try {
                    const result = await AuthService.VerificateCaptch(this.userInput.toUpperCase(), this.guidId)
                    this.errorCaptcha = !result
                    return result
                } catch (error) {
                    console.error('Error verifying captcha:', error)
                    this.errorCaptcha = true
                    return false
                }
            },
            shuffleString(str) {
                let array = str.split('')
                for (let i = array.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1))
                    const temp = array[i]
                    array[i] = array[j]
                    array[j] = temp
                }
                return array.join('')
            },
            async login() {
                if (this.username && this.password) {
                    this.errorLogin = false
                    this.loading = true

                    // First verify captcha
                    const captchaValid = await this.verifyCaptcha()
                    if (!captchaValid) {
                        this.loading = false
                        return
                    }

                    AuthService.login(this.username, this.password, this.userInput.toUpperCase(), this.guidId)
                        .then(async (res) => {

                            if (res.data.statusCode == 206) {
                                await this.$store.dispatch('user/setUser2FA', res.data)
                                window.location.href = '/2FA'
                            } else {
                                await this.$store.dispatch('user/setUserSession', res.data)
                                await this.$store.dispatch('app/fetch_options')
                                window.location.href = '/'
                            }
                        })
                        .catch((error) => {
                            // A network failure (API down, CORS, connection reset) rejects with no
                            // `response` at all. Reading error.response.data.message directly threw a
                            // TypeError here, so `loading` was never cleared and the button spun forever.
                            const message = error && error.response && error.response.data ? error.response.data.message : null
                            if (message == 'notActivated') {
                                this.errorLocked = true
                            } else {
                                this.errorLogin = true
                            }
                            this.loading = false
                            this.generateCaptcha()
                        })
                
                } else {
                    this.errorLogin = true
                    this.loading = false
                }
            }
        }
    }
</script>


<style scoped>
    .login-main-container { height: 100%; overflow: hidden; width: 100%; background: url(../assets/images/LoginBG.jpg); background-repeat: no-repeat; background-size: cover; background-position: center }

    .login-center-container { width: auto; margin: 0 auto; max-width: 400px }
    .captcha-container { text-align: center; }

    .captcha-text { font-size: 24px; margin-bottom: 10px; color: #333; background: url(../assets/images/captcha.jpg); }

        .captcha-text span { display: inline-block; font-family: Arial, sans-serif; letter-spacing: 8px; text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5); }

    .captcha-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; }

        .captcha-overlay::before,
        .captcha-overlay::after { content: ''; position: absolute; width: 100%; height: 1px; background-color: #ccc; }

        .captcha-overlay::before { top: 30%; }

        .captcha-overlay::after { bottom: 30%; }


    .captcha-button { background-color: #4CAF50; color: white; padding: 10px 20px; border: none; border-radius: 4px; cursor: pointer; }

        .captcha-button:hover { background-color: #45a049; }

    .captcha-regenerate { cursor: pointer; margin-left: 10px; font-size: 24px; color: #2196F3; }

        .captcha-regenerate:hover { color: #1976D2; }

    .verification-message { margin-top: 10px; font-weight: bold; }
</style>
